import { type AllProductDTO } from '@cart-services/types'

const NEW_PRODUCT_THRESHOLD_DAYS = 60

/**
 * 判斷單一 variation 是否為新品
 * - 有 product_create_time 且距今 ≤ 60 天→ 新品
 * - 無 product_create_time 或超過 60 天 → 非新品
 */
export const isNewProduct = (
  productCreateTime: string | undefined,
  thresholdDays = NEW_PRODUCT_THRESHOLD_DAYS,
): boolean => {
  if (!productCreateTime) return false
  const createDate = new Date(productCreateTime)
  const now = new Date()
  const diffDays = (now.getTime() - createDate.getTime()) / (1000 * 60 * 60 * 24)
  return diffDays <= thresholdDays
}

/**
 * 判斷母商品底下是否有任何新品 variation
 */
export const hasAnyNewProductVariation = (product: AllProductDTO): boolean =>
  product.variations.some(variation => isNewProduct(variation.product_create_time))

/**
 * 過濾出含有新品 variation 的母商品
 */
export const filterNewProducts = (products: AllProductDTO[]): AllProductDTO[] =>
  products.filter(hasAnyNewProductVariation)
